import { createSelector as createReselectSelector } from 'reselect';
import { createSelector as createReduxOrmSelector } from 'redux-orm';

import orm from '../orm';
import matchPaths from '../utils/match-paths';
import Paths from '../constants/Paths';

export const pathnameSelector = ({
  router: {
    location: { pathname },
  },
}) => pathname;

export const pathsMatchSelector = createReselectSelector(pathnameSelector, (pathname) =>
  matchPaths(pathname, Object.values(Paths)),
);

export const pathSelector = createReduxOrmSelector(
  orm,
  pathsMatchSelector,
  ({ Factory, Site, Device }, pathsMatch) => {
    if (pathsMatch) {
      switch (pathsMatch.path) {
        case Paths.FACTORIES: {
          const factoryModel = Factory.withId(pathsMatch.params.id);

          return {
            factoryId: factoryModel && factoryModel.id,
          };
        }
        case Paths.SITES: {
          const siteModel = Site.withId(pathsMatch.params.id);
          const factoryModel = siteModel && siteModel.factory;

          if (!factoryModel) {
            return {
              siteId: null,
              factoryId: null,
            };
          }

          return {
            siteId: siteModel.id,
            factoryId: factoryModel.id,
          };
        }
        case Paths.DEVICES: {
          const deviceModel = Device.withId(pathsMatch.params.id);
          const siteModel = deviceModel && deviceModel.site;
          const factoryModel = siteModel && siteModel.factory;

          if (!factoryModel) {
            return {
              deviceId: null,
              siteId: null,
              factoryId: null,
            };
          }

          return {
            deviceId: deviceModel.id,
            siteId: siteModel.id,
            factoryId: factoryModel.id,
          };
        }
        default:
      }
    }

    return {};
  },
);
